export default "__VITE_ASSET__9nB4xsYI__"